import { ArrowUpRight } from 'lucide-react';
import type { ChangeRequest } from '@/api/types';
import { externalLink, viaApi } from '@/lib/initiatives';

/** «через API» and the link to the initiative in the client's system, on both sides' cards (MK42-6384). */
export function ViaApi({ c }: { c: Pick<ChangeRequest, 'author' | 'externalUrl' | 'externalId'> }) {
  if (!viaApi(c)) return null;
  const url = externalLink(c);
  return (
    <span className="mt-1 flex flex-wrap items-center gap-x-2 text-xs text-muted" data-testid="via-api">
      <span className="rounded-sm bg-sunken px-1.5 py-0.5">через API</span>
      {url ? (
        <a href={url} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-0.5 underline underline-offset-2">
          {c.externalId ? `${c.externalId} во внешней системе` : 'Открыть во внешней системе'} <ArrowUpRight className="size-3" />
        </a>
      ) : (
        c.externalId && <span>№ {c.externalId}</span>
      )}
    </span>
  );
}
